module.exports = __webpack_public_path__ + "img/search-icon-blue.891ca013.svg";